export default __webpack_public_path__ + "static/media/labs (3).3d609eec.JPG";